import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Entity } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ExplorerEntityDetailsLayout, NavigatorMain } from '@shapeable/ui';
import { ExplorerChallengesViewLayout } from './explorer-challenges-view-layout';
import { ExplorerChallengesBannerLayout } from './explorer-challenges-banner-layout';
import { ChallengesNavigator } from '../elements/challenges-navigator';
import NAVIGATOR_ICON from '../../images/navigator.png';
const cls = classNames('explorer-challenges-layout');

// -------- Types -------->

export type ExplorerChallengesLayoutProps = Classable & HasChildren & { 
  entity?: Entity;
};

export const ExplorerChallengesLayoutDefaultProps: Omit<ExplorerChallengesLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->


const ContainerStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background: ${theme.COLOR('bright')};
  `,
});

const LayoutStyles = breakpoints({
  base: css`

  `,
  desktop: css`
    
  `,
});

const NavigatorStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,
    NavigatorMobile: styled(NavigatorMain)`${NavigatorStyles}`,
};

export const ExplorerChallengesLayout: Shapeable.FC<ExplorerChallengesLayoutProps> = (props) => {
  const { className, children, entity } = props;
  
  return (
    <My.Container className={cls.name(className)}>
      <My.Layout
        asideMaxWidth={800}
        asideHeaderProps={{ navigationProps: { showIcon: false }}}
        entity={entity}
        isAsideSticky
        stickyTopOffset={106}
        asideIsOffset={false}
        showSiteFooter={() => true}
        showAsideHeader={false}
        
        banner={
          <ExplorerChallengesBannerLayout entity={entity} />
        }
        content={
          <ExplorerChallengesViewLayout entity={entity} />
        }
        dataViz={
          <ChallengesNavigator />
        }

        // aside
        dataVizMain={
          <My.NavigatorMobile 
            dataVizComponent={ChallengesNavigator} 
            imageSrc={NAVIGATOR_ICON}
            label='Challenges Navigator'
            />
        }
      />
      {children}
    </My.Container>
  )
};

ExplorerChallengesLayout.defaultProps = ExplorerChallengesLayoutDefaultProps;
ExplorerChallengesLayout.cls = cls;